import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {VisitPlanHttpService} from "../../services/visit-plan-http.service";
import {Store} from "@ngrx/store";
import {CommonsFacadeService} from "../../../../commons/angular/state/commons/commons-facade.service";
import {catchError, concatMap, finalize, map, mergeMap, of, withLatestFrom} from "rxjs";
import {VisitPlanJobModel} from "../../../models/visit-plan-job.model";
import {VisitPlanJobAPiActions} from "./visit-plan-job.actions";
import {visitPlanJobFeature} from "./visit-plan-job.state";

export const getVisitPlanJobs = createEffect(
  (actions$ = inject(Actions),
   visitPlanHttpService = inject(VisitPlanHttpService),
   visitPlanJobStore = inject(Store<VisitPlanJobModel>),
   commonsFacadeService: CommonsFacadeService = inject(CommonsFacadeService)
  ) => {
    return actions$.pipe(
      ofType(VisitPlanJobAPiActions.getVisitPlanJobs),
      concatMap(payload =>
        of(payload).pipe(
          withLatestFrom(visitPlanJobStore.select(visitPlanJobFeature.selectCursor()))
        )
      ),
      mergeMap(([payload, cursor]) => {
        // commonsFacadeService.setLoaderOn();
        let paramsCopy = {...payload.params}
        if (!!cursor) {
          paramsCopy.cursor = cursor;
        }
        return visitPlanHttpService.getVisitPlanScheduleJobs(payload.visitPlanId, payload.visitPlanScheduleId, paramsCopy).pipe(
          map((res: {
            list: VisitPlanJobModel[]
            cursor: string
          }) => VisitPlanJobAPiActions.getVisitPlanJobsSuccess({
            visitPlanJobs: res.list,
            cursor: res.cursor
          })),
          catchError((error: {
            message: string
          }) => of(VisitPlanJobAPiActions.getVisitPlanJobsFailure({error}))),
          finalize(() => {
            // commonsFacadeService.setLoaderOff()
          })
        )
      })
    );
  },
  {functional: true}
);
